export default __webpack_public_path__ + "static/media/compiegne8.629fcca6.jpg";